import * as React from 'react';
import './assets/Login.scss';
// @ts-ignore
import bgImage from './assets/img/background.jpeg';
import LoginAadButton from '../LoginAAD/LoginAadButton';

export interface ILoginComponentProps {}

class LoginLight extends React.Component<ILoginComponentProps> {
  render() {
    return (
      <React.Fragment>
        <div className="bground">
          <img src={bgImage} width="100%" height="100%" alt="Background" />
        </div>
        <div className="container-fluid layout">
          <div className="row banner">
            <div className="col-lg-5 offset-lg-1 app-info">
              <h1 className="warning">Logged Out</h1>
              <div className="card card-body bg-dark well">
                You have been logged out by your own action or a period of
                inactivity. Click Sign in to log in again.
              </div>
              This website is developed and maintained by LexisNexis on behalf
              of the Nebraska Department of Transportation to serve as a portal
              into their crash repository.
            </div>
            <div className="col-lg-3 login offset-lg-2">
              <div>
                <LoginAadButton
                  buttonText="Sign in"
                  className="btn btn-secondary btn-lg signInButton"
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default LoginLight;
